import { useQuery } from 'react-query';

import type { ITeam } from 'src/api/users-api';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';

type OrgTeamsResponse = {
    teams: ITeam[];
};

const ORG_TEAMS_PATH = 'api/landlord/orgs/teams';

export const useOrgTeams = (disabled?: boolean) => {
    return useQuery<OrgTeamsResponse>(
        [queryKeys.orgTeams],
        async () => {
            return await apiClient(ORG_TEAMS_PATH).json<OrgTeamsResponse>();
        },
        { enabled: !disabled, retry: false, refetchOnWindowFocus: false }
    );
};
